import { createAction, props } from '@ngrx/store';
import {
  AllowedMoveCategories,
  CommunicationTypes,
  CompanyAttribute,
  CreateRuleBasedSubGroup,
  CreateSubGroup,
  CreateUser,
  CreateUserRow,
  CreateUsersRequest,
  CreateUsersResponse,
  DeleteUserDto,
  EditGroup,
  FieldValidationError,
  Group,
  HierarchyDto,
  MoveGroupRequest,
  OrganisationGroupModel,
  User,
  UserAttribute,
  UserCommunicationStatus,
  ValidationStatusEnum,
} from '../../shared/models';

export enum Type {
  ORGANIZATION_TREE_TABLE_LOADING = '[ORGANIZATION] ORGANIZATION_TREE_TABLE_LOADING',
  ORGANIZATION_TREE_TABLE_LOADING_COMPLETE = '[ORGANIZATION] ORGANIZATION_TREE_TABLE_LOADING_COMPLETE',
  USER_TABLE_LOADING = '[ORGANIZATION] USER_TABLE_LOADING',
  USER_TABLE_LOADING_COMPLETE = '[ORGANIZATION] USER_TABLE_LOADING_COMPLETE',
  DELETED_GROUPS_TABLE_LOADING = '[ORGANIZATION] DELETED_GROUPS_TABLE_LOADING',
  DELETED_GROUPS_TABLE_LOADING_COMPLETE = '[ORGANIZATION] DELETED_GROUPS_TABLE_LOADING_COMPLETE',
  SET_DELETED_GROUPS_COUNT = '[ORGANIZATION] SET_DELETED_GROUPS_COUNT',
  SET_ORPHAN_GROUPS_COUNT = '[ORGANIZATION] SET_ORPHAN_GROUPS_COUNT',
  ORPHAN_GROUPS_TABLE_LOADING = '[ORGANIZATION] ORPHAN_GROUPS_TABLE_LOADING',
  ORPHAN_GROUPS_TABLE_LOADING_COMPLETE = '[ORGANIZATION] ORPHAN_GROUPS_TABLE_LOADING_COMPLETE',
  FETCH_USERS = '[ORGANIZATION] FETCH_USERS',
  FETCH_USERS_SUCCESS = '[ORGANIZATION] FETCH_USERS_SUCCESS',
  FETCH_USERS_ERROR = '[ORGANIZATION] FETCH_USERS_ERROR',
  FETCH_USER_ATTRIBUTES_SUCCESS = '[ORGANIZATION] FETCH_USER_ATTRIBUTES_SUCCESS',
  FETCH_USER_ATTRIBUTES_ERROR = '[ORGANIZATION] FETCH_USER_ATTRIBUTES_ERROR',
  FETCH_GROUP_USERS = '[ORGANIZATION] FETCH_GROUP_USERS',
  FETCH_MANAGERS_USERS = '[ORGANIZATION] FETCH_MANAGERS_USERS',
  FETCH_MANAGERS_USERS_SUCCESS = '[ORGANIZATION] FETCH_MANAGERS_USERS_SUCCESS',
  FETCH_MANAGERS_USERS_ERROR = '[ORGANIZATION] FETCH_MANAGERS_USERS_ERROR',
  SELECT_USERS = '[ORGANIZATION] SELECT_USERS',
  DESELECT_USERS = '[ORGANIZATION] DESELECT_USERS',
  FETCH_TREE = '[ORGANIZATION] FETCH_TREE',
  FETCH_TREE_SUCCESS = '[ORGANIZATION] FETCH_TREE_SUCCESS',
  FETCH_TREE_ERROR = '[ORGANIZATION] FETCH_TREE_ERROR',
  UPDATE_GROUPIDSANDUSERIDS = '[ORGANIZATION] UPDATE_GROUPIDSANDUSERIDS',
  FETCH_GROUPIDSANDUSERIDS = '[ORGANIZATION] FETCH_GROUPIDSANDUSERIDS',
  FETCH_GROUPIDSANDUSERIDS_SUCCESS = '[ORGANIZATION] FETCH_GROUPIDSANDUSERIDS_SUCCESS',
  FETCH_GROUPIDSANDUSERIDS_ERROR = '[ORGANIZATION] FETCH_GROUPIDSANDUSERIDS_ERROR',
  FETCH_COMPANY_ATTRIBUTES = '[ORGANIZATION] FETCH_COMPANY_ATTRIBUTES',
  FETCH_COMPANY_ATTRIBUTES_SUCCESS = '[ORGANIZATION] FETCH_COMPANY_ATTRIBUTES_SUCCESS',
  FETCH_COMPANY_ATTRIBUTES_ERROR = '[ORGANIZATION] FETCH_COMPANY_ATTRIBUTES_ERROR',
  FETCH_GROUP = '[ORGANIZATION] FETCH_GROUP',
  FETCH_GROUP_ERROR = '[ORGANIZATION] FETCH_GROUP_ERROR',
  FETCH_USER_IDS_FOR_GROUP = '[ORGANIZATION] FETCH_USER_IDS_FOR_GROUP',
  FETCH_USER_IDS_FOR_GROUP_SUCCESS = '[ORGANIZATION] FETCH_USER_IDS_FOR_GROUP_SUCCESS',
  VALIDATE_USER = '[ORGANIZATION] VALIDATE_USER',
  VALIDATE_USER_SUCCESS = '[ORGANIZATION] VALIDATE_USER_SUCCESS',
  VALIDATE_USER_FAILED = '[ORGANIZATION] VALIDATE_USER_FAILED',
  VALIDATE_USER_ERROR = '[ORGANIZATION] VALIDATE_USER_ERROR',
  ADD_USER = '[ORGANIZATION] ADD_USER',
  ADD_USER_SUCCESS = '[ORGANIZATION] ADD_USER_SUCCESS',
  ADD_USER_ERROR = '[ORGANIZATION] ADD_USER_ERROR',
  ADD_USERS_TO_GROUP_SUCCESS = '[ORGANIZATION] ADD_USERS_TO_GROUP_SUCCESS',
  ADD_USERIDS_TO_GROUP_SUCCESS = '[ORGANIZATION] ADD_USERIDS_TO_GROUP_SUCCESS',
  EDIT_USER = '[ORGANIZATION] EDIT_USER',
  EDIT_USER_SUCCESS = '[ORGANIZATION] EDIT_USER_SUCCESS',
  EDIT_USER_ERROR = '[ORGANIZATION] EDIT_USER_ERROR',
  EDIT_USERS = '[ORGANIZATION] EDIT_USERS',
  EDIT_USERS_SUCCESS = '[ORGANIZATION] EDIT_USERS_SUCCESS',
  EDIT_USERS_ERROR = '[ORGANIZATION] EDIT_USERS_ERROR',
  SELECT_GROUPS = '[ORGANIZATION] SELECT_GROUPS',
  DESELECT_GROUPS = '[ORGANIZATION] DESELECT_GROUPS',
  SELECT_HIERARCHY = '[ORGANIZATION] SELECT_HIERARCHY',
  ADD_GROUP = '[ORGANIZATION] ADD_GROUP',
  ADD_GROUP_SUCCESS = '[ORGANIZATION] ADD_GROUP_SUCCESS',
  ADD_GROUP_VALIDATION_FAIL = '[ORGANIZATION] ADD_GROUP_VALIDATION_FAIL',
  ADD_GROUP_ERROR = '[ORGANIZATION] ADD_GROUP_ERROR',
  ADD_RULEBASED_GROUP = '[ORGANIZATION] ADD_RULEBASED_GROUP',
  EDIT_RULEBASED_GROUP = '[ORGANIZATION] EDIT_RULEBASED_GROUP',
  EDIT_GROUP = '[ORGANIZATION] EDIT_GROUP',
  EDIT_GROUP_SUCCESS = '[ORGANIZATION] EDIT_GROUP_SUCCESS',
  EDIT_GROUP_VALIDATION_FAIL = '[ORGANIZATION] EDIT_GROUP_VALIDATION_FAIL',
  EDIT_GROUP_ERROR = '[ORGANIZATION] EDIT_GROUP_ERROR',
  UPDATE_VALIDATION_STATUS = '[ORGANIZATION] UPDATE_VALIDATION_STATUS',
  MOVE_GROUP = '[ORGANIZATION] MOVE_GROUP',
  MOVE_GROUP_SUCCESS = '[ORGANIZATION] MOVE_GROUP_SUCCESS',
  MOVE_GROUP_ERROR = '[ORGANIZATION] MOVE_GROUP_ERROR',
  MOVE_GROUPS = '[ORGANIZATION] MOVE_GROUPS',
  MOVE_GROUPS_SUCCESS = '[ORGANIZATION] MOVE_GROUPS_SUCCESS',
  FETCH_ALLOWED_MOVE_CATEGORIES = '[ORGANIZATION] FETCH_ALLOWED_MOVE_CATEGORIES',
  FETCH_ALLOWED_MOVE_CATEGORIES_SUCCESS = '[ORGANIZATION] FETCH_ALLOWED_MOVE_CATEGORIES_SUCCESS',
  FETCH_ALLOWED_MOVE_CATEGORIES_ERROR = '[ORGANIZATION] FETCH_ALLOWED_MOVE_CATEGORIES_ERROR',
  SELECT_GROUP_ROWS = '[ORGANIZATION] SELECT_GROUP_ROWS',
  SELECT_ROWS = '[ORGANIZATION] SELECT_ROWS',
  MOVE_USERS = '[ORGANIZATION] MOVE_USERS',
  MOVE_USERS_SUCCESS = '[ORGANIZATION] MOVE_USERS_SUCCESS',
  MOVE_USERS_ERROR = '[ORGANIZATION] MOVE_USERS_ERROR',
  DELETE_SEGMENT = '[ORGANIZATION] DELETE_SEGMENT',
  DELETE_GROUP = '[ORGANIZATION] DELETE_GROUP',
  DELETE_GROUP_SUCCESS = '[ORGANIZATION] DELETE_GROUP_SUCCESS',
  DELETE_GROUP_ERROR = '[ORGANIZATION] DELETE_GROUP_ERROR',
  DELETE_USERS = '[ORGANIZATION] DELETE_USERS',
  DELETE_USERS_SUCCESS = '[ORGANIZATION] DELETE_USERS_SUCCESS',
  DELETE_USERS_ERROR = '[ORGANIZATION] DELETE_USERS_ERROR',
  SET_LOADING_INDICATORS_FOR_ROWS = '[ORGANIZATION] SET_LOADING_INDICATORS_FOR_ROWS',
  CLEAR_ERROR = '[ORGANIZATION] CLEAR_ERROR',
  SET_ACTIVE_SWITCH_OPTION = '[ORGANIZATION] SET_ACTIVE_SWITCH_OPTION',
  SET_SEARCH_STRING = '[ORGANIZATION] SET_SEARCH_STRING',
  IMPORT_SEGMENT_USERS_SUCCESS = '[ORGANIZATION] IMPORT_SEGMENT_USERS_SUCCESS',
  RESET_STATE = '[ORGANIZATION] RESET_STATE',
  REMOVE_USERS = '[ORGANIZATION] REMOVE_USERS',
  SET_ACTIVE_INSTANCE = '[ORGANIZATION] SET_ACTIVE_INSTANCE',
  REMOVE_INSTANCE_STATE = '[ORGANIZATION] REMOVE_INSTANCE_STATE',
  SET_ACTIVE_ACTIONBAR_INSTANCE = '[ORGANIZATION] SET_ACTIVE_ACTIONBAR_INSTANCE',
  CREATE_USERS = '[ORGANIZATION] CREATE_USERS',
  CREATE_USERS_SUCCESS = '[ORGANIZATION] CREATE_USERS_SUCCESS',
  CREATE_USERS_ERROR = '[ORGANIZATION] CREATE_USERS_ERROR',
  CREATE_RULEBASED_TEAM_WITH_USERS = '[ORGANIZATION] CREATE_RULEBASED_TEAM_WITH_USERS',
  PREVIEW_TEAM_CREATION = '[ORGANIZATION] PREVIEW_TEAM_CREATION',
  CREATE_RULEBASED_TEAM_WITH_USERS_ERROR = '[ORGANIZATION] CREATE_RULEBASED_TEAM_WITH_USERS_ERROR',
  DELETE_MANAGER_FROM_TEAM = '[ORGANIZATION] DELETE_MANAGER_FROM_TEAM',
  EDIT_RULEBASED_TEAM_WITH_USERS = '[ORGANIZATION] EDIT_RULEBASED_TEAM_WITH_USERS',
  DELETE_TEAM_AND_REMOVE_ATTRIBUTES = '[ORGANIZATION] DELETE_TEAM_AND_REMOVE_ATTRIBUTES',
  IMPORT_USERS_TO_TEAM = '[ORGANIZATION] IMPORT_USERS_TO_TEAM',
  IMPORT_USERS_TO_TEAM_SUCCESS = '[ORGANIZATION] IMPORT_USERS_TO_TEAM_SUCCESS',
  IMPORT_USERS_TO_TEAM_ERROR = '[ORGANIZATION] IMPORT_USERS_TO_TEAM_ERROR',
  CHECK_COMMUNICATION_SENT_STATUSES = '[ORGANIZATION] CHECK_COMMUNICATION_SENT_STATUSES',
  CHECK_COMMUNICATION_SENT_STATUSES_SUCCESS = '[ORGANIZATION] CHECK_COMMUNICATION_SENT_STATUSES_SUCCESS',
  CHECK_COMMUNICATION_SENT_STATUSES_ERROR = '[ORGANIZATION] CHECK_COMMUNICATION_SENT_STATUSES_ERROR',
  SET_COMMUNICATION_SENT = '[ORGANIZATION] SET_COMMUNICATION_SENT',
  REMOVE_MEMBERS_FROM_TEAM = '[ORGANIZATION] REMOVE_MEMBERS_FROM_TEAM',
  REMOVE_MEMBERS_FROM_TEAM_SUCCESS = '[ORGANIZATION] REMOVE_MEMBERS_FROM_TEAM_SUCCESS',
  REMOVE_MEMBERS_FROM_TEAM_ERROR = '[ORGANIZATION] REMOVE_MEMBERS_FROM_TEAM_ERROR',
}

// Loading Actions (No Payload)
export const OrganizationTreeTableLoading = createAction(Type.ORGANIZATION_TREE_TABLE_LOADING);
export const OrganizationTreeTableLoadingComplete = createAction(
  Type.ORGANIZATION_TREE_TABLE_LOADING_COMPLETE,
);
export const UserTableLoading = createAction(Type.USER_TABLE_LOADING);
export const UserTableLoadingComplete = createAction(Type.USER_TABLE_LOADING_COMPLETE);
export const DeletedGroupsTableLoading = createAction(Type.DELETED_GROUPS_TABLE_LOADING);
export const DeletedGroupsTableLoadingComplete = createAction(
  Type.DELETED_GROUPS_TABLE_LOADING_COMPLETE,
);
export const OrphanGroupsTableLoading = createAction(Type.ORPHAN_GROUPS_TABLE_LOADING);
export const OrphanGroupsTableLoadingComplete = createAction(
  Type.ORPHAN_GROUPS_TABLE_LOADING_COMPLETE,
);
export const clearError = createAction(Type.CLEAR_ERROR);
export const resetState = createAction(Type.RESET_STATE);

// Actions with Payloads
export const SetDeletedGroupsCount = createAction(
  Type.SET_DELETED_GROUPS_COUNT,
  props<{ payload: number }>(),
);

export const SetOrphanGroupsCount = createAction(
  Type.SET_ORPHAN_GROUPS_COUNT,
  props<{ payload: number }>(),
);

export const fetchUsers = createAction(Type.FETCH_USERS, props<{ companyId: number }>());

export const fetchUsersSuccess = createAction(Type.FETCH_USERS_SUCCESS, props<{ users: User[] }>());

export const fetchUsersError = createAction(Type.FETCH_USERS_ERROR, props<{ error: string }>());

export const fetchUserAttributesSuccess = createAction(
  Type.FETCH_USER_ATTRIBUTES_SUCCESS,
  props<{ userAttributes: { userId: number; attributes: UserAttribute[] }[] }>(),
);

export const fetchUserAttributesError = createAction(
  Type.FETCH_USER_ATTRIBUTES_ERROR,
  props<{ error: string }>(),
);
export const fetchManagersUsers = createAction(
  Type.FETCH_MANAGERS_USERS,
  props<{ userId: number }>(),
);

export const fetchManagersUsersSuccess = createAction(
  Type.FETCH_MANAGERS_USERS_SUCCESS,
  props<{ users: number[] }>(),
);

export const fetchManagersUsersError = createAction(
  Type.FETCH_MANAGERS_USERS_ERROR,
  props<{ error: string }>(),
);

export const fetchGroupUsers = createAction(
  Type.FETCH_GROUP_USERS,
  props<{ companyId: number; groupId: number }>(),
);

export const fetchGroup = createAction(
  Type.FETCH_GROUP,
  props<{ companyId: number; groupId: number }>(),
);

export const fetchGroupError = createAction(Type.FETCH_GROUP_ERROR, props<{ error: string }>());

export const fetchUserIdsForGroup = createAction(
  Type.FETCH_USER_IDS_FOR_GROUP,
  props<{ groupId: number }>(),
);
export const fetchUserIdsForGroupSuccess = createAction(
  Type.FETCH_USER_IDS_FOR_GROUP_SUCCESS,
  props<{ hierarchyId: number; groupId: number; userIds: number[] }>(),
);
export const selectUsers = createAction(
  Type.SELECT_USERS,
  props<{ instanceId: string; ids: number[] }>(),
);

export const deselectUsers = createAction(
  Type.DESELECT_USERS,
  props<{ instanceId: string; ids: number[] }>(),
);

export const fetchTree = createAction(Type.FETCH_TREE, props<{ companyId: number }>());

export const fetchTreeSuccess = createAction(
  Type.FETCH_TREE_SUCCESS,
  props<{ tree: HierarchyDto<OrganisationGroupModel>[] }>(),
);

export const fetchTreeError = createAction(Type.FETCH_TREE_ERROR, props<{ error: string }>());

export const updateGroupIdsAndUserIds = createAction(
  Type.UPDATE_GROUPIDSANDUSERIDS,
  props<{ hierarchyId: number; groupIdsAndUserIds: Record<number, number[]> }>(),
);

export const fetchGroupIdsAndUserIds = createAction(
  Type.FETCH_GROUPIDSANDUSERIDS,
  props<{ hierarchyId: number }>(),
);

export const fetchGroupIdsAndUserIdsSuccess = createAction(
  Type.FETCH_GROUPIDSANDUSERIDS_SUCCESS,
  props<{ hierarchyId: number; groupIdsAndUserIds: Record<number, number[]> }>(),
);

export const fetchGroupIdsAndUserIdsError = createAction(
  Type.FETCH_GROUPIDSANDUSERIDS_ERROR,
  props<{ error: string }>(),
);

export const fetchCompanyAttributes = createAction(
  Type.FETCH_COMPANY_ATTRIBUTES,
  props<{ companyId: number }>(),
);

export const fetchCompanyAttributesSuccess = createAction(
  Type.FETCH_COMPANY_ATTRIBUTES_SUCCESS,
  props<{ attributes: CompanyAttribute[] }>(),
);

export const fetchCompanyAttributesError = createAction(
  Type.FETCH_COMPANY_ATTRIBUTES_ERROR,
  props<{ error: string }>(),
);

export const validateUser = createAction(Type.VALIDATE_USER, props<{ user: CreateUser }>());

export const validateUserFailed = createAction(
  Type.VALIDATE_USER_FAILED,
  props<{ fields: FieldValidationError[] }>(),
);

export const validateUserSuccess = createAction(
  Type.VALIDATE_USER_SUCCESS,
  props<{ fields: FieldValidationError[] }>(),
);

export const validateUserError = createAction(Type.VALIDATE_USER_ERROR, props<{ error: string }>());

export const addUser = createAction(Type.ADD_USER, props<{ user: CreateUser }>());

export const addUserSuccess = createAction(Type.ADD_USER_SUCCESS, props<{ user: User }>());

export const addUsersToGroup = createAction(
  Type.ADD_USERS_TO_GROUP_SUCCESS,
  props<{ hierarchyId: number; groupId: number; users: User[] }>(),
);

export const addUserIdsToGroup = createAction(
  Type.ADD_USERIDS_TO_GROUP_SUCCESS,
  props<{ hierarchyId: number; groupId: number; userIds: number[] }>(),
);

export const addUserError = createAction(Type.ADD_USER_ERROR, props<{ error: string }>());

export const editUser = createAction(Type.EDIT_USER, props<{ user: CreateUser }>());

export const editUserSuccess = createAction(Type.EDIT_USER_SUCCESS, props<{ user: User }>());

export const editUserError = createAction(Type.EDIT_USER_ERROR, props<{ error: string }>());

export const editUsers = createAction(Type.EDIT_USERS, props<{ users: CreateUser[] }>());

export const editUsersSuccess = createAction(Type.EDIT_USERS_SUCCESS, props<{ users: User[] }>());

export const editUsersError = createAction(Type.EDIT_USERS_ERROR, props<{ error: string }>());

export const selectGroups = createAction(Type.SELECT_GROUPS, props<{ ids: number[] }>());

export const deselectGroups = createAction(Type.DESELECT_GROUPS, props<{ ids: number[] }>());

export const selectHierarchy = createAction(Type.SELECT_HIERARCHY, props<{ id: number }>());

export const addGroup = createAction(
  Type.ADD_GROUP,
  props<{
    parentGroupId: number;
    group: CreateSubGroup;
    leaf: boolean;
    manager: { id: number; name: string; email: string };
  }>(),
);

export const addGroupSuccess = createAction(
  Type.ADD_GROUP_SUCCESS,
  props<{
    hierarchyId: number;
    categoryId: number;
    parentId: number;
    group: Group;
    leaf: boolean;
    manager?: { id: number; name: string; email: string };
    replacesGroupId?: number;
    replacesUserIds?: number[];
  }>(),
);

export const addGroupValidationFail = createAction(
  Type.ADD_GROUP_VALIDATION_FAIL,
  props<{ error: string }>(),
);

export const addGroupError = createAction(Type.ADD_GROUP_ERROR, props<{ error: string }>());

export const addRuledBasedGroup = createAction(
  Type.ADD_RULEBASED_GROUP,
  props<{
    parentGroupId: number;
    hierarchyId: number;
    group: CreateRuleBasedSubGroup;
    leaf: boolean;
    manager: { id: number; name: string; email: string };
  }>(),
);

export const editRuledBasedGroup = createAction(
  Type.EDIT_RULEBASED_GROUP,
  props<{
    group: EditGroup;
    manager: { id: number; name: string; email: string };
    currentManagerId?: number;
  }>(),
);

export const editGroup = createAction(
  Type.EDIT_GROUP,
  props<{
    group: EditGroup;
    manager: { id: number; name: string; email: string };
    currentManagerId?: number;
  }>(),
);

export const editGroupSuccess = createAction(
  Type.EDIT_GROUP_SUCCESS,
  props<{
    group: Group;
    manager: { id: number; name: string; email: string };
    currentManagerId?: number;
  }>(),
);

export const editGroupValidationFail = createAction(
  Type.EDIT_GROUP_VALIDATION_FAIL,
  props<{ error: string }>(),
);

export const editGroupError = createAction(Type.EDIT_GROUP_ERROR, props<{ error: string }>());

export const updateValidationStatus = createAction(
  Type.UPDATE_VALIDATION_STATUS,
  props<{ validationStatus: ValidationStatusEnum }>(),
);

export const moveGroup = createAction(
  Type.MOVE_GROUP,
  props<{ groupId: number; hierarchyId: number; currentParentId: number; newParentId: number }>(),
);

export const moveGroupSuccess = createAction(
  Type.MOVE_GROUP_SUCCESS,
  props<{ groupId: number; hierarchyId: number; currentParentId: number; newParentId: number }>(),
);

export const moveGroupError = createAction(Type.MOVE_GROUP_ERROR, props<{ error: string }>());

export const moveGroups = createAction(
  Type.MOVE_GROUPS,
  props<{ companyId: number; request: MoveGroupRequest }>(),
);

export const moveGroupsSuccess = createAction(
  Type.MOVE_GROUPS_SUCCESS,
  props<{ companyId: number; request: MoveGroupRequest }>(),
);

export const fetchAllowedMoveCategories = createAction(
  Type.FETCH_ALLOWED_MOVE_CATEGORIES,
  props<{ companyId: number }>(),
);

export const fetchAllowedMoveCategoriesSuccess = createAction(
  Type.FETCH_ALLOWED_MOVE_CATEGORIES_SUCCESS,
  props<{ allowedMoveCategories: AllowedMoveCategories[] }>(),
);

export const fetchAllowedMoveCategoriesError = createAction(
  Type.FETCH_ALLOWED_MOVE_CATEGORIES_ERROR,
  props<{ error: string }>(),
);

export const selectGroupRows = createAction(Type.SELECT_GROUP_ROWS, props<{ ids: number[] }>());

export const selectRows = createAction(Type.SELECT_ROWS, props<{ ids: number[] }>());

export const moveUsers = createAction(
  Type.MOVE_USERS,
  props<{ companyId: number; hierarchyId: number; newGroupId: number; userIds: number[] }>(),
);

export const moveUsersSuccess = createAction(
  Type.MOVE_USERS_SUCCESS,
  props<{ hierarchyId: number; groupId: number; userIds: number[]; usersAfterMove: User[] }>(),
);

export const moveUsersError = createAction(Type.MOVE_USERS_ERROR, props<{ error: string }>());

export const deleteSegment = createAction(Type.DELETE_SEGMENT, props<{ groupId: number }>());

export const deleteGroup = createAction(Type.DELETE_GROUP, props<{ groupId: number }>());

export const deleteGroupSuccess = createAction(
  Type.DELETE_GROUP_SUCCESS,
  props<{ groupId: number }>(),
);

export const deleteGroupError = createAction(
  Type.DELETE_GROUP_ERROR,
  props<{ groupId: number; error: string }>(),
);

export const deleteTeamAndRemoveAttributes = createAction(
  Type.DELETE_TEAM_AND_REMOVE_ATTRIBUTES,
  props<{ groupId: number; userIds: number[]; hierarchyId?: number }>(),
);

export const removeUsers = createAction(
  Type.REMOVE_USERS,
  props<{ userIds: number[]; hierarchyId: number; groupId: number }>(),
);

export const deleteUsers = createAction(
  Type.DELETE_USERS,
  props<{ companyId: number; model: DeleteUserDto }>(),
);

export const deleteUsersSuccess = createAction(
  Type.DELETE_USERS_SUCCESS,
  props<{ userIds: number[]; hierarchyId: number }>(),
);

export const deleteUsersError = createAction(Type.DELETE_USERS_ERROR, props<{ error: string }>());

export const setLoadingIndicatorsForRows = createAction(
  Type.SET_LOADING_INDICATORS_FOR_ROWS,
  props<{ rowIds: number[] }>(),
);

export const setActiveSwitchOption = createAction(
  Type.SET_ACTIVE_SWITCH_OPTION,
  props<{ option: string }>(),
);

export const setSearchString = createAction(
  Type.SET_SEARCH_STRING,
  props<{ instanceId: string; searchstring: string }>(),
);

export const importSegmentUsersSuccess = createAction(
  Type.IMPORT_SEGMENT_USERS_SUCCESS,
  props<{ groupId: number; hierarchyId: number; users: User[] }>(),
);

export const setActiveInstance = createAction(
  Type.SET_ACTIVE_INSTANCE,
  props<{ instanceId: string }>(),
);

export const removeInstanceState = createAction(
  Type.REMOVE_INSTANCE_STATE,
  props<{ instanceId: string }>(),
);

export const setActiveActionBarInstance = createAction(
  Type.SET_ACTIVE_ACTIONBAR_INSTANCE,
  props<{ instanceId: string; componentInstanceId: string }>(),
);

export const createUsers = createAction(
  Type.CREATE_USERS,
  props<{ request: CreateUsersRequest }>(),
);

export const createUsersSuccess = createAction(
  Type.CREATE_USERS_SUCCESS,
  props<{ response: CreateUsersResponse }>(),
);

export const createUsersError = createAction(Type.CREATE_USERS_ERROR, props<{ error: string }>());

export const createRuleBasedTeamWithUsers = createAction(
  Type.CREATE_RULEBASED_TEAM_WITH_USERS,
  props<{
    companyId: number;
    parentGroupId: number;
    hierarchyId: number;
    temporaryGroupId: number;
    teamName: string;
    group: CreateRuleBasedSubGroup;
    manager: { id: number; name: string; email: string } | undefined;
    managerEmail?: string;
    managerIsAlsoMember?: boolean;
    inviteManager?: boolean;
    sendWelcomeEmail?: boolean;
    optimisticMembers?: User[];
    usersRequest?: CreateUsersRequest;
    managerUserRequest?: CreateUserRow;
    existingMemberIdsToAdd?: number[];
  }>(),
);

export const previewTeamCreation = createAction(
  Type.PREVIEW_TEAM_CREATION,
  props<Omit<ReturnType<typeof createRuleBasedTeamWithUsers>, 'type'>>(),
);

export const createRuleBasedTeamWithUsersError = createAction(
  Type.CREATE_RULEBASED_TEAM_WITH_USERS_ERROR,
  props<{ error: string }>(),
);

export const deleteManagerFromTeam = createAction(
  Type.DELETE_MANAGER_FROM_TEAM,
  props<{
    companyId: number;
    hierarchyId: number;
    userId: number;
    teamsToUnmanage: EditGroup[];
    currentManagerId: number;
  }>(),
);

export const editRuleBasedTeamWithUsers = createAction(
  Type.EDIT_RULEBASED_TEAM_WITH_USERS,
  props<{
    companyId: number;
    hierarchyId: number;
    group: EditGroup;
    currentManagerId?: number;
  }>(),
);

// Adds members to a team. The reducer inserts optimistic placeholder cards for
// newMembers and moves existingMemberIdsToAdd immediately; the effect persists
// both and dispatches success (reconcile) or error (rollback).
export const importUsersToTeam = createAction(
  Type.IMPORT_USERS_TO_TEAM,
  props<{
    companyId: number;
    hierarchyId: number;
    groupId: number;
    newMembers?: User[];
    existingMemberIdsToAdd?: number[];
    sendWelcomeEmail?: boolean;
  }>(),
);

export const importUsersToTeamSuccess = createAction(
  Type.IMPORT_USERS_TO_TEAM_SUCCESS,
  props<{
    hierarchyId: number;
    groupId: number;
    tempUserIds: number[];
    createdUsers: User[];
    movedUsers: User[];
  }>(),
);

export const importUsersToTeamError = createAction(
  Type.IMPORT_USERS_TO_TEAM_ERROR,
  props<{ error: string }>(),
);

export const checkCommunicationSentStatuses = createAction(Type.CHECK_COMMUNICATION_SENT_STATUSES);

export const checkCommunicationSentStatusesSuccess = createAction(
  Type.CHECK_COMMUNICATION_SENT_STATUSES_SUCCESS,
  props<{ statuses: UserCommunicationStatus[] }>(),
);

export const checkCommunicationSentStatusesError = createAction(
  Type.CHECK_COMMUNICATION_SENT_STATUSES_ERROR,
  props<{ error: string }>(),
);

export const setCommunicationSent = createAction(
  Type.SET_COMMUNICATION_SENT,
  props<{ userId: number; communicationType: CommunicationTypes }>(),
);

// Removes users from a team's group and clears their team attribute.
// The reducer applies the change optimistically; the effect persists it and
// reconciles/rolls back based on the server response.
export const removeMembersFromTeam = createAction(
  Type.REMOVE_MEMBERS_FROM_TEAM,
  props<{ userIds: number[]; hierarchyId: number; groupId: number }>(),
);

export const removeMembersFromTeamSuccess = createAction(
  Type.REMOVE_MEMBERS_FROM_TEAM_SUCCESS,
  props<{ users: User[] }>(),
);

export const removeMembersFromTeamError = createAction(
  Type.REMOVE_MEMBERS_FROM_TEAM_ERROR,
  props<{ error: string }>(),
);
